import { render, staticRenderFns } from "./SubmitPlan.vue?vue&type=template&id=32d5c82b&scoped=true"
import script from "./SubmitPlan.vue?vue&type=script&lang=js"
export * from "./SubmitPlan.vue?vue&type=script&lang=js"
import style0 from "./SubmitPlan.vue?vue&type=style&index=0&id=32d5c82b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d5c82b",
  null
  
)

export default component.exports